import React, { Fragment, useEffect, useState } from "react";
import "./DefaultHeader.scss";
import verasLogo from "./../../Assets/Images/verasLogo.png";
import smallLogo from "./../../Assets/Images/smallImage.png";
import { Dropdown, SplitButton } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { uiLogout } from "../../Utils/actions/auth";
import { useTranslation } from "react-i18next";
// import Settings from "./Settings";
// import BCSettings from "./BCSettings";
import i18n from "./../../translations/i18n";
import { Button } from "@material-ui/core";
import { Avatar, List, Menu, MenuItem, ListItem } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import AppsIcon from "@mui/icons-material/Apps";
import CloudIcon from "@mui/icons-material/Cloud";
import DashboardIcon from "@mui/icons-material/Dashboard";
import TuneIcon from "@mui/icons-material/Tune";
import VerifiedIcon from "@mui/icons-material/Verified";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import LogoutIcon from "@mui/icons-material/Logout";
import { Link, useLocation, useParams } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";

import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";

import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";

const DefaultHeader = ({ activeButton, setActiveButton }) => {
  // eslint-disable-next-line
  const [language, setLanguage] = useState("en");
  // const [show, setShow] = useState(false);
  // const [bcShow, setBCShow] = useState(false);
  const { t } = useTranslation();
  // const [anchorEl, setAnchorEl] = React.useState(null);
  // const open = Boolean(anchorEl);
  const [isJustLoggedIn, setIsJustLoggedIn] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  const [menuEl, setMenuEl] = useState(null);
  // const [activeButton, setActiveButton] = useState(null);
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const dispatch = useDispatch();
  // eslint-disable-next-line

  const { cmpntGroup } = useSelector((state) => state.data);
  // const { isAuthenticated, username } = useSelector((state) => state.auth);

  const handleLogout = () => {
    setIsJustLoggedIn(true);
    dispatch(uiLogout());
  };

  useEffect(() => {
    if (isJustLoggedIn) {
      setAnchorEl(null);
      setIsJustLoggedIn(false);
    }
  }, [isJustLoggedIn]);

  const location = useLocation();
  const drawerWidth = 240;

  // const { activeLink } = useParams();

  const btnStyle = {
    borderBottom: "1px solid #286685",
    width: "100%",
    // border: "none",
    borderRadius: "0px",
    color: "#c7c7c7",
    // fontStyle: "bold !important",
  };
  const underlineStyle = {
    borderBottom: "3px solid #ed7d31",
  };

  useEffect(() => {
    i18n.changeLanguage(language);
  }, [language]);

  const groupList = {
    jobs: { naming: "Home", values: ["jobs"], linkName: "dashboard" },
    user: {
      naming: "Administration",
      values: ["user", "appProperties", "audit"],
      linkName: "user",
    },
    configuration: {
      naming: "App Settings",
      values: ["configuration", "dataProvider"],
      linkName: "appConfig",
    },
    dq: { naming: "DQ Results", values: ["dq"], linkName: "dq" },
    logs: { naming: "View Logs", values: ["logs"], linkName: "logs" },
    serverInfo: {
      naming: "Server Health",
      values: ["serverInfo"],
      linkName: "serverInfo",
    },
    reports: { naming: "Reports", values: ["reports"], linkName: "reports" },
    syncService: {
      naming: "Sync Service",
      values: ["syncService"],
      linkName: "syncService",
    },
  };

  const iconsList = {
    serverInfo: <CloudIcon />,
    user: <PersonIcon />,
    dashboard: <DashboardIcon />,
    configForm: <TuneIcon />,
    dq: <VerifiedIcon />,
    logs: <VerifiedIcon />,
  };

  useEffect(() => {
    // console.log("activeButton>>>", activeButton )
    if (activeButton === "configForm") {
      setActiveButton("appConfig");
    } else {
      setActiveButton(activeButton);
    }
  }, [activeButton]);

  // const dashboardChild = {configForm: 'Config Page', jobs: 'Jobs List', logs: 'Logs List'}
  // const userChild = {userRoles: 'User Roles', userPerm: 'User Perm'}

  const handleToggle = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleClose = () => {
    setDropdownOpen(false);
  };

  const handleAppComClick = (event) => {
    setMenuEl(event.currentTarget);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleButtonClick = (buttonKey) => {
    setActiveButton(buttonKey);
  };
  // const splitBtn = {

  // }

  const handleComponent = (cmpnt) => {
    window.location = "/veras/#/" + cmpnt;
  };

  const handleChange = () => {};

  const handleAppMenusClose = () => {
    // handleComponent("manage")
    setMenuEl(null);
  };

  const handleAppClose = () => {
    setAnchorEl(null);
  };

  const items = [
    { image: "../../../Assets/Images/ss-logo.png", label: "Username" },
  ];

  // const cmpntGroup = {
  //   dashboard: true,
  //   user: true,
  //   configForm: true,
  //   jobs: true,
  //   dq: true,
  // };
  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: "center", backgroundColor:"#333333" }}>
      <Typography
        variant="h6"
        component="div"
        // sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' } }}
      >
        <Link to={"/dashboard"}>
          <img className={"bc-logo"} src={smallLogo} height={40} alt={"logo"} />
        </Link>
      </Typography>
      <Divider />
      <List>
        {JSON.parse(sessionStorage.getItem("isAuthenticated")) ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              paddingLeft: "10px",
              alignItems: "flex-start",
            }}
          >
            {Object.keys(groupList).map((key) => {
              const group = groupList[key];
              const shouldRenderLink = group?.values.some((componentName) => {
                const component = cmpntGroup[componentName];
                return component && component.Read;
              });

              return shouldRenderLink ? (
                <Link
                  to={`/${groupList[key].linkName}`}
                  key={groupList[key].linkName}
                  style={{ textDecoration: "none" }}
                >
                  <Button
                    className="navbtn"
                    variant={"info"}
                    // className={"mr-3"}
                    style={{
                      ...btnStyle,
                      borderBottom:
                        activeButton == groupList[key].linkName
                          ? "2px solid white"
                          : "none",
                      textTransform: "none",
                    }}
                    onClick={() => handleButtonClick(groupList[key].linkName)}
                  >
                    {/* {console.log('activeButton >>>> ', activeButton , groupList[key].linkName)} */}
                    <b className="navtext">{groupList[key].naming}</b>
                  </Button>
                </Link>
              ) : null;
            })}{" "}
          </div>
        ) : (
          ""
        )}
      </List>
    </Box>
  );

  return (
    <>
      <Box sx={{ display: "flex" }} style={{ height: "7vh" }}>
        <CssBaseline />
        <AppBar
          component="nav"
          style={{
            backgroundColor: "#242424",
            boxShadow: "none",
            height: "7vh",
            padding: "0px",
          }}
        >
          <Toolbar
            style={{
              color: "rgb(47 107 137)",
              marginTop: "auto",
              marginBottom: "auto",
              minHeight: "auto",
            }}
          >
            {JSON.parse(sessionStorage.getItem("isAuthenticated")) ? (
              <>
                <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  edge="start"
                  onClick={handleDrawerToggle}
                  sx={{ mr: 2, display: { sm: "none" } }}
                >
                  <MenuIcon className="menu-icon" />
                </IconButton>

                <Typography
                  variant="h6"
                  component="div"
                  sx={{ flexGrow: 1, display: { xs: "none", sm: "block" } }}
                >
                  <Link to={"/"}>
                    <img
                      className={"bc-logo"}
                      src={verasLogo}
                      height={40}
                      alt={"logo"}
                    />
                  </Link>
                </Typography>

                <Typography
                  variant="h6"
                  component="div"
                  sx={{ flexGrow: 1, display: { xs: "block", sm: "none" } }}
                >
                  <Link to={"/"}>
                    <img src={smallLogo} height={40} alt={"logo"} />
                  </Link>
                </Typography>
              </>
            ) : (
              <Typography
                variant="h6"
                component="div"
                sx={{ flexGrow: 1, display: { sm: "block" } }}
              >
                <Link to={"/"}>
                  <img
                    className={"bc-login-logo"}
                    src={verasLogo}
                    height={40}
                    alt={"logo"}
                  />
                </Link>
              </Typography>
            )}

            <Box
              sx={{ display: { xs: "none", sm: "flex" } }}
              style={{
                flex: "1 0 75%",
                justifyContent: "left",
              }}
            >
              {JSON.parse(sessionStorage.getItem("isAuthenticated")) ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    paddingLeft: "10px",
                    alignItems: "flex-start",
                  }}
                >
                  {Object.keys(groupList).map((key) => {
                    const group = groupList[key];
                    const shouldRenderLink = group?.values.some(
                      (componentName) => {
                        const component = cmpntGroup[componentName];
                        return component && component.Read;
                      }
                    );

                    return shouldRenderLink ? (
                      <Link
                        to={`/${groupList[key].linkName}`}
                        key={groupList[key].linkName}
                        style={{ textDecoration: "none" }}
                      >
                        <Button
                          className="navbtn"
                          variant={"info"}
                          // className={"mr-3"}
                          style={{
                            ...btnStyle,
                            borderBottom:
                              activeButton === groupList[key].linkName
                                ? "2px solid #c7c7c7"
                                : "none",
                            textTransform: "none",
                          }}
                          onClick={() =>
                            handleButtonClick(groupList[key].linkName)
                          }
                        >
                          <b className="navtext">{groupList[key].naming}</b>
                        </Button>
                      </Link>
                    ) : null;
                  })}{" "}
                </div>
              ) : (
                ""
              )}
              {/* {JSON.parse(sessionStorage.getItem("isAuthenticated")) ? (
                Object.keys(groupList).length > 0 ? Object.keys(groupList).map((n) => (
                  groupList[n] && cmpntGroup[n]?.Read && cmpntGroup[n] !== "" ?
                    <Link to={`${n === 'configForm' ? '/appConfig' : '/' + n}`} style={{ textDecoration: 'none' }}>
                      <Button
                      className="navbtn"
                        variant={"info"}
                        // className={"mr-3"}
                        style={{ ...btnStyle, borderBottom: activeButton === n ? "2px solid #c7c7c7" : "none", textTransform: 'none' }}
                        onClick={() => handleButtonClick(n)}
                      >
                        <b className="navtext">{groupList[n]}</b>
                      </Button>
                    </Link> : null)
                ) : null
              ) : ""} */}
            </Box>
            <Box>
              {JSON.parse(sessionStorage.getItem("isAuthenticated")) ? (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <Link
                    to={`/manage`}
                    className="myAcc"
                    style={{
                      color: "#c7c7c7",
                      textDecoration: "none",
                      display: "flex",
                      marginRight: "6px",
                    }}
                  >
                    <strong>{t("manageAcc")}</strong>
                  </Link>
                  <div style={{ border: "1px solid #c7c7c7" }}></div>
                  <div>
                    <div className="AppIcon d-flex justify-content-center align-items-center">
                      {/* <PersonIcon
                      
                      /> */}

                      <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleAppClose}
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          padding: "0px",
                          // gap: "2",

                          // position: "fixed",
                        }}
                      >
                        <List
                          component="nav"
                          aria-label="main mailbox folders"
                          style={{
                            padding: "0px",
                          }}
                        >
                          {/* {!isLogOut && (  */}
                          <ListItem
                            className="menuItem"
                            onClick={handleLogout}
                            style={{
                              padding: "0px 5px 5px 5px",
                              cursor: "pointer",
                            }}
                          >
                            <LogoutIcon />
                            <Button
                              style={{ fontSize: "12px", padding: "0px" }}
                            >
                              {t("logout")}
                            </Button>
                          </ListItem>
                          {/* )} */}
                          {/* Add more ListItem components as needed */}
                        </List>
                      </Menu>

                      <div className="d-flex" onClick={handleClick}>
                        <strong
                          className="user_name"
                          style={{ color: "#c7c7c7", marginLeft: "5px" }}
                        >
                          {sessionStorage.getItem("username")
                            ? sessionStorage.getItem("username")
                            : ""}
                        </strong>
                        <AccountCircleIcon
                          className="userLogo"
                          style={{
                            fontSize: 20,
                            color: "#c7c7c7",
                            marginLeft: "2px",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
            </Box>
          </Toolbar>
        </AppBar>
        <nav>
          <Drawer
            // container={container}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
            sx={{
              display: { xs: "block", sm: "none" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
                backgroundColor: "#333333",
              },
              backgroundColor: "#333333",
            }}
          >
            {drawer}
          </Drawer>
        </nav>
      </Box>
    </>
  );
};

export default DefaultHeader;
